import { types, flow, getRoot, applySnapshot } from 'mobx-state-tree';
import { IRootStore } from 'store/root';
import { CoreApi, AccountApi, RegionalApi } from 'service/axios-api';
import Wallet from './wallet';
import Notifications from './notification';

const NewsletterProductStatus = types.model('NewsletterProductStatus', {
    productId: types.string,
    emailNewsletterStatus: types.string,
});

const SmsNewsletterProductStatus = types.model('SmsNewsletterProductStatus', {
    productId: types.string,
    smsNewsletterStatus: types.string,
});

const UserInfo = types
    .model('UserInfo', {
        // userNo: types.optional(types.number, 0),
        countryCode: types.optional(types.string, ''),
        phoneNo: types.optional(types.string, ''),
        enableUserPhoneReset: types.optional(types.boolean, true),
        email: types.optional(types.string, ''),
        nexonTag: types.optional(types.string, ''),
        renamesRemaining: types.optional(types.number, 0),
        wallet: types.optional(Wallet, {}),
        notifications: types.optional(Notifications, {}),
        isVerified: types.optional(types.boolean, false), // email verification,
        userNewsletterStatusList: types.optional(types.array(NewsletterProductStatus), []),
        userSmsNewsletterStatusList: types.optional(types.array(SmsNewsletterProductStatus), []),
    })
    .views((self) => ({
        get root(): IRootStore {
            return getRoot<IRootStore>(self);
        },
        get profileName(): string {
            const index = self.nexonTag.lastIndexOf('#');
            return self.nexonTag.substr(0, index);
        },
        get tagCode(): string {
            const index = self.nexonTag.lastIndexOf('#');
            return self.nexonTag.substr(index);
        },
        get userOptedInAnyEmail(): boolean {
            return !!self.userNewsletterStatusList.find((x) => x.emailNewsletterStatus === 'OPT_IN');
        },
        get userOptedInAnySms(): boolean {
            return !!self.userSmsNewsletterStatusList.find((x) => x.smsNewsletterStatus === 'OPT_IN');
        },
    }))
    .actions((self) => ({
        fetch: flow(function* () {
            const data = yield AccountApi.get('/account');
            applySnapshot(self, data);
        }),
    }))
    .actions((self) => ({
        resendAccountVerification() {
            AccountApi.post('/no-auth/id/request-verify', {
                id: self.email,
            });
        },
        updateNexonTag(newProfileName: string) {
            return CoreApi.put('/nexon-tag/v1', { nexonTag: newProfileName });
        },
        subscribeEmail(productId: string) {
            return RegionalApi.post('/user/newsletter', {
                productId,
                newsletterType: 0,
                newsletterStatus: 1,
                newsletterPath: 0,
            });
        },
        subscribeEmailAll() {
            return RegionalApi.post('user/newsletter/all', {
                newsletterType: 0,
                newsletterPath: 0,
            });
        },
    }));

export default UserInfo;
